import React from 'react';
import styled from 'styled-components';
import ArticleListItem from './ArticleListItem';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import InfiniteScroll from 'react-infinite-scroll-component';

const Wrapper = styled.div`
  padding: 15px 0;
  margin-bottom: 87px;
`;

const EmptyList = styled.div`
  padding: 20px 24px;
  font-size: 22px;
  line-height: 28px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2px;
  color: #031C38;
`;

const NewsFeedArticles = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

interface Props {
  data: any;
  fetchNewsFeedHandler: any;
  hasMore: any;
}

const ArticleList = ({ data, hasMore, fetchNewsFeedHandler }: Props) => {

  if (!data || data.length < 1) {
    return (
      <Wrapper>
        <EmptyList>
          <span>Great content is</span>
          <span>coming soon!</span>
        </EmptyList>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <NewsFeedArticles>
        <InfiniteScroll
          dataLength={data.length}
          next={fetchNewsFeedHandler}
          hasMore={hasMore}
          loader={
            <div className="mb-20">
              <LoadingContent layout="flex" />
            </div>
          }
        >
          {data.map((article) => (
            <ArticleListItem key={article && article.id} itemData={article} />
          ))}
        </InfiniteScroll>
      </NewsFeedArticles>
    </Wrapper>
  );
};

export default ArticleList;
